import breakfast from "../../assets/ui/meals/breakfast-sunrise.png";
import lunch from "../../assets/ui/meals/lunch-sun.png";
import dinner from "../../assets/ui/meals/dinner-moon.png";
import snack from "../../assets/ui/meals/snack-apple.png";

export const meals = [
  { type: "breakfast", label: "Завтрак", image: breakfast },
  { type: "lunch", label: "Обед", image: lunch },
  { type: "dinner", label: "Ужин", image: dinner },
  { type: "snack", label: "Перекус", image: snack },
] as const;

